import { Toaster } from "sonner-native";

import { TOAST_DURATION_IN_MS, TOAST_WIDTH_WEB } from "@/domain/constants";
import { useAppTheme } from "@/hooks/useAppTheme";
import { usePlatformOS } from "@/hooks/usePlatformOS";

export const VnToaster = () => {
  const { theme, resolvedColors } = useAppTheme();
  const { isWeb } = usePlatformOS();

  return (
    <Toaster
      position="top-center"
      duration={TOAST_DURATION_IN_MS}
      theme={theme}
      closeButton
      style={{
        backgroundColor: resolvedColors.background,
        borderColor: resolvedColors.border,
        borderWidth: 1,
        width: isWeb ? TOAST_WIDTH_WEB : undefined,
        marginHorizontal: isWeb ? "auto" : 32,
      }}
    />
  );
};
